import React from 'react';
import classNames from 'classnames';

export interface ListCountProps {
  className?: string;
  isRight?: boolean;
  //件数
  count: number;
}

const ListCount: React.FC<ListCountProps> = ({ className, isRight, count }) => {
  return (
    <div className={className} data-testid={'count'}>
      <div className={classNames('uc-pagination-wrapper u-flex', isRight && 'u-justify-end')}>
        <div className='uc-pagination-help u-text-m u-mr16' data-testid='list-count--all-count'>
          全{count}件
        </div>
      </div>
    </div>
  );
};

export default ListCount;
